import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import { encryptPassword } from '../../../utils';
import * as mobileActions from '../../../actions/mobile';

class SaveMobile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			password: ''
		}
	}
	
	handleChangePassword(event) {
		this.setState({password: event.target.value});
	}
	
	handleSaveMobile(event) {
		event.preventDefault();
		var encryptedPassword = encryptPassword(this.state.password);
		this.props.saveMobile(encryptedPassword);
	}

	getErrorPassword() {
		if (this.props.mobile.status === 5) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{trans('error_verify_password')}
				</div>
			);
		}
	}
	
	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{(this.props.userInfo.mobile_no === '') ? trans('bind_mobile_title') : trans('change_mobile_title')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__form">
								<form method="post" action="" id="J-validated-form" onSubmit={this.handleSaveMobile.bind(this)}>
									<div className="content__form-input">
										<input type="password" className="content__form-input-widget J-validated-field"
											placeholder={trans('current_password_placeholder')} id="J-form-curpwd"
											onChange={this.handleChangePassword.bind(this)}>
										</input>
									</div>
									<div className="content__form-errmsg" id="J-errdisplay-curpwd">
										{this.getErrorPassword()}
									</div>
									<div className="content__submit-wrap">
										<input type="submit" className="content__submit" value={trans('bind_action')}></input>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		mobile: state.mobile
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, mobileActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveMobile);


// WEBPACK FOOTER //
// ./app/components/security/mobile/SaveMobile.js